import { Button } from "@/components/ui/button";
import { Pencil, X } from "lucide-react";
import { EditTimeForRecordAlert } from "./EditTimeForRecordAlert";
import booking from "@/shared/api/booking";
import { toast } from "sonner";
import { useEffect, useState } from "react";


export const EditTimeForRecordForm = ({ currentTime, name, id, handleBookingChanged, disabled, disabledTime }) => {
    const timeSlots = Array.from({ length: 11 }, (_, i) => {
        const hour = 9 + i
        const _time = `${hour.toString().padStart(2, '0')}:00`
        if (disabledTime?.includes(_time)) return undefined;
        return _time;
    }).filter(time => time);

    const [editMode, setEditMode] = useState(false);
    const [time, setTime] = useState(timeSlots[0]);



    useEffect(() => {
        console.log(time)
    }, [time])

    const handleBookingEdit = async (e) => {
        e.preventDefault();
        try {
            console.log(time)
            const res = await booking.changeBookingTime(id, time);
            if (res) {
                toast.success("Запись успешно изменена");

                handleBookingChanged((prev) => {
                    if (!prev) return new Map();

                    const newMap = new Map(prev);

                    // Найдём дату, в которой есть запись с этим id
                    for (const [date, bookings] of newMap.entries()) {
                        const record = bookings.find((b) => b._id === id);

                        if (!record) continue;

                        record.time = time;
                        newMap.set(date, bookings.map(b => b._id === id ? record : b));
                        break;
                    }

                    return newMap;
                });

                setEditMode(false);
                setTime(currentTime);
            } else {
                toast.error("Ошибка при изменении записи");
            }
        } catch (error) {
            toast.error("Ошибка при изменении записи");
            console.error(error);
        }
    }

    if (editMode) return (
        <div className="flex gap-2 items-start">
            <select
                className="w-full rounded-lg border border-foreground p-2 max-w-xs h-[36px]"
                value={time}
                onChange={(e) => setTime(e.target.value)}
            >
                {timeSlots.map(time => (
                    <option key={time} value={time}>
                        {time}
                    </option>
                ))}
            </select>
            <EditTimeForRecordAlert name={name} handleBookingEdit={handleBookingEdit} />
            <Button variant="outline" onClick={() => {
                setEditMode(false);
                setTime(currentTime);
            }}>
                <X className="h-4 w-4" />
            </Button>
        </div>
    )

    return (
        <Button variant="outline" disabled={disabled} size="sm" onClick={() => setEditMode(true)}>
            <Pencil className="h-4 w-4 mr-1" />
            Сменить время
        </Button >
    )
}